/* eslint-disable no-param-reassign */
import { abortUpload } from '@socialive/common';

export default (state, action) => {
  const { id } = action.payload;
  if (state[id].uploading) {
    state[id].canceling = true;
    state[id].uploading = false;
    abortUpload(id);
  }
};
